<div 
  *ngIf="showLoader()" 
  class="loader-overlay"
>
  <div class="loader"></div>
</div>